// Custom EMS style values to be imported

// Colors
export const emsDarkGrey = "#666666";
export const emsDarkGreyHover = "hsl(0, 0%, 28%)";
export const emsMediumGrey = "#cccccc";
export const emsLightGrey = "#f0f0f0";
export const emsWarningRed = "#ce1e2f";
export const emsBackgroundRed = "#fee9ea";
export const emsWarningYellow = "#FFEA00";
export const emsBackgroundYellow = "#fffeb4";
export const callToBackground = "#D3EAE2";
export const callToBorder = "#7FB5A1";
export const callToTagGreen = "#006b43";

// Padding
export const paddingSmall = "10px";
export const paddingMedium = "15px";
export const paddingLarge = "30px";